import React from "react";

const Header = () => {
  return (
    <header
      style={{ backgroundColor: "#3CD3AD", color: "#000", padding: "1rem" }}
    >
      <h1 style={{ textAlign: "center", margin: 0 }}>Pokemon Dashboard</h1>
    </header>
  );
};

export default Header;
